import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'zh',
  events: 'input',
  dictionary: {
    zh: {
      messages: {
        required: (field) => field + ' 欄位必填',
        min: (field, args) => field + ' 最少' + args + '個字',
        max: (field, args) => field + ' 不得超過' + args + '個字',
        digits: (field, args) => field + ' 請輸入' + args + '位數字',
        min_value: (field, args) => field + ' 不得少於' + args,
        max_value: (field, args) => field + ' 不得超過' + args,
        integer: (field) => field + ' 必須為整數',
        regex: (field) => '無效的 ' + field,
        email: (field) => field + ' 請輸入正確Email格式',
        confirmed: () => '密碼不相符',
        youtubeLink: (field) => field + ' 不是youtube內嵌影片連結格式'
      },
      attributes: {
        account: '帳號',
        password: '密碼'
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js